<template>
    <div>
        <p v-html="description"></p>
    </div>
</template>

<script>
export default {
    name: 'Area',
    computed: {
        description () {
            return this.$t(`openlegal.${this.$route.name}.description`)
        }
    }
}
</script>

<style scoped lang="scss">
    /deep/{
        ul, ul li{
            list-style-type: disc !important;
        }

        ol li{
            list-style-type: decimal !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/Area.vue